(() => {

  var CollectionBundleHighlightApp = (() => {
    const maxWidth = 1180;
    var setPaddingWidthProperty = () => {
      document.querySelectorAll('[js-collection-bundle-highlight]').forEach(element => {
        element.style.setProperty('--padding-left', (element.clientWidth - maxWidth) / 2 + 'px');
      });
    }
    var initialize = () => {
      window.dispatchEvent(new Event('resize'));
      window.addEventListener('resize', () => {
        setPaddingWidthProperty();
      })
    }
    return {
      init: initialize
    }
  })();


  var AnchorApp = (() => {
    var initialize = () => {
      if (window.location.hash === '#bundles') {
        setTimeout(() => {
          if (window.innerWidth < 960) {
            const bundlesSection = document.querySelector('.product-bundle__mobile');
            if (bundlesSection) {
              window.scrollTo(0, bundlesSection.getBoundingClientRect().top - 100 + window.scrollY);
            }
          } else {
            const bundlesSection = document.querySelector('.product-bundle__desktop');
            if (bundlesSection) {
              window.scrollTo(0, bundlesSection.getBoundingClientRect().top - 100 + window.scrollY);
            }
          }
        }, 500);
      }
      if (window.location.hash === '#mobile-pdp-size-picker') {
        setTimeout(() => {
          if (window.innerWidth < 960) {
            const targetSection = document.querySelector('.product__size-picker.desktop-hide');
            if (targetSection) {
              window.scrollTo(0, targetSection.getBoundingClientRect().top - 100 + window.scrollY);
            }
          }
        }, 500);
      }
    }
    return {
      init: initialize
    }
  })();

  // Custom dropdown initialization function
  var initializeCustomDropdowns = () => {
    document.querySelectorAll('[js-custom-option-select]:not(.select-hidden)').forEach(function(selectElement) {
        var numberOfOptions = selectElement.children.length;
        var optionName = selectElement.dataset.optionName
        if(optionName) {
            optionName = optionName + ' : '
        } else {
            optionName = ''
        }
        selectElement.classList.add('select-hidden');

        var wrapper = document.createElement('div');
        wrapper.className = 'select';
        selectElement.parentNode.insertBefore(wrapper, selectElement);
        wrapper.appendChild(selectElement);

        var styledSelect = document.createElement('div');
        styledSelect.className = 'select-styled';
        styledSelect.textContent = optionName + selectElement.querySelector("option[selected]").textContent;
        wrapper.appendChild(styledSelect);

        var list = document.createElement('ul');
        list.className = 'select-options';
        wrapper.appendChild(list);

        for (var i = 0; i < numberOfOptions; i++) {
            var listItem = document.createElement('li');
            listItem.textContent = selectElement.children[i].textContent;
            listItem.setAttribute('rel', selectElement.children[i].value);
            list.appendChild(listItem);

            if (selectElement.children[i].selected) {
                listItem.classList.add('is-selected');
            }
        }

        var listItems = list.children;

        styledSelect.addEventListener('click', function(e) {
            e.stopPropagation();
            document.querySelectorAll('div.select-styled.active').forEach(function(activeStyledSelect) {
                if (activeStyledSelect !== styledSelect) {
                    activeStyledSelect.classList.remove('active');
                    activeStyledSelect.nextElementSibling.style.display = 'none';
                }
            });
            styledSelect.classList.toggle('active');
            list.style.display = styledSelect.classList.contains('active') ? 'block' : 'none';
        });

        styledSelect.insertAdjacentHTML('beforeend', `<div class="select-styled-icon"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 0.984374L7 4.98438L13 0.984375" stroke="#2B2B2B" stroke-linecap="round" stroke-linejoin="round"/>
</svg></div>`);

        Array.from(listItems).forEach(function(listItem) {
            listItem.addEventListener('click', function(e) {
                e.stopPropagation();
                let optionName = styledSelect.closest('.select').querySelector('select').dataset.optionName
                if(optionName) {
                    optionName = optionName + ' : '
                } else {
                    optionName=''
                }
                styledSelect.textContent = optionName + listItem.textContent;
                
                styledSelect.classList.remove('active');
                selectElement.value = listItem.getAttribute('rel');
                list.querySelector('li.is-selected').classList.remove('is-selected');
                listItem.classList.add('is-selected');
                list.style.display = 'none';
                styledSelect.insertAdjacentHTML('beforeend', `<div class="select-styled-icon"><svg width="14" height="6" viewBox="0 0 14 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 0.984374L7 4.98438L13 0.984375" stroke="#2B2B2B" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </div>`);
                selectElement.dispatchEvent(new Event('change', {'view': window,'bubbles': true}))
            });

        });

        document.addEventListener('click', function() {
            styledSelect.classList.remove('active');
            list.style.display = 'none';
        });
    });
  };

  var ProductMeasurementInfoWrapperApp = (() => {
    var switchElement = (variant_id) => {
      document.querySelectorAll('[js-product-measurement-info-wrapper]').forEach(element => {
        if (element.getAttribute('data-variant-id') == String(variant_id)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
    }
    var initialize = () => {
      document.addEventListener('product:variant-change', (event) => {
        switchElement(event.detail.variant.id)
      });
    }
    return {
      init: initialize
    }
  })();

  var PDPSizePickerApp = (() => {
    var initializeAllAnimations = (container) => {
      if (!container) return;

      container.querySelectorAll('.animation-fade-up-reveal:not(.animation-initialized)').forEach(element => {
        element.classList.add('animation-initialized');
      });
    };

    // Helper: ensure only one [name="id"] (hidden) is submitted
    var normalizeIdInputs = (formEl, variantId) => {
      if (!formEl) return;
      // Remove name from any non-hidden id fields to avoid duplicate submission
      formEl.querySelectorAll('[name="id"]').forEach(node => {
        if (!(node.tagName && node.tagName.toLowerCase() === 'input' && node.type === 'hidden')) {
          node.setAttribute('data-name', 'id');
          node.removeAttribute('name');
          // Also disable to prevent accidental serialization by libraries
          node.disabled = true;
        }
      });
      // Ensure hidden input exists and has correct value
      let hidden = formEl.querySelector('input[type="hidden"][name="id"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'id';
        formEl.appendChild(hidden);
      }
      if (variantId) hidden.value = variantId;
    };

    // Helper: set [name="id"] based on current option selections
    var syncHiddenIdFromOptions = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const sectionEl = productSection.querySelector('[data-section-id]') || document.querySelector('[data-section-id]');
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        if (!sectionEl || !formEl) {
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: missing section/form', { hasSection: !!sectionEl, hasForm: !!formEl });
          return;
        }
        let productData;
        const productJsonEl = document.querySelector('#ProductJson-' + sectionEl.getAttribute('data-section-id'));
        if (productJsonEl) {
          try { productData = JSON.parse(productJsonEl.textContent); } catch(_) {}
        } else if (window.__pdpProductData) {
          productData = window.__pdpProductData;
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: using cached product data');
        } else {
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: missing productJson, using fallbacks');
        }

        // Gather selected option values in order from variants block, then form, then section
        const variantsWrap = productSection.querySelector('[data-product-variants]');
        let optionInputs = [];
        if (variantsWrap) optionInputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) optionInputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) optionInputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
        const selectedOptions = optionInputs.map(input => input.value);

        // Try resolve via product data + options first
        let variantIdToUse;
        if (productData && productData.variants && selectedOptions.length) {
          const matched = productData.variants.find(v => v && v.options && selectedOptions.every((val, idx) => String(v.options[idx]) === String(val)));
          if (matched) variantIdToUse = matched.id;
        }

        // Fallbacks in order
        if (!variantIdToUse) {
          const currentVariantIdAttr = variantsWrap?.getAttribute('data-current-variant-id');
          if (currentVariantIdAttr) {
            variantIdToUse = currentVariantIdAttr;
            console.log('[PDPSizePicker] syncHiddenIdFromOptions: used data-current-variant-id', { variantIdToUse });
          }
        }
        if (!variantIdToUse && formEl.dataset.currentProductId) {
          variantIdToUse = formEl.dataset.currentProductId;
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: used form dataset currentProductId', { variantIdToUse });
        }
        if (!variantIdToUse) {
          const idSelect = formEl.querySelector('select[data-name="id"], select[name="id"]');
          const value = idSelect?.value || idSelect?.getAttribute('value');
          if (value) {
            variantIdToUse = value;
            console.log('[PDPSizePicker] syncHiddenIdFromOptions: used fallback idSelect', { id: value });
          }
        }

        if (variantIdToUse) {
          normalizeIdInputs(formEl, variantIdToUse);
          formEl.setAttribute('data-current-product-id', variantIdToUse);
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: set id', { selectedOptions, variantIdToUse });
        } else {
          console.log('[PDPSizePicker] syncHiddenIdFromOptions: no variant resolved', { selectedOptions });
        }
      } catch (e) {
        console.log('syncHiddenIdFromOptions failed:', e);
      }
    };

    // Helper: fully reinitialize the product section via Shopify Sections API
    var reinitProductSection = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]');
        if (!productSection) {
          console.log('[PDPSizePicker] reinitProductSection: no product section found');
          return;
        }
        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.sections) {
          if (typeof window.Shopify.theme.sections.unload === 'function') {
            console.log('[PDPSizePicker] sections.unload called');
            window.Shopify.theme.sections.unload(productSection);
          }
          if (typeof window.Shopify.theme.sections.load === 'function') {
            console.log('[PDPSizePicker] sections.load called');
            window.Shopify.theme.sections.load(productSection);
          } else {
            const evt = new Event('shopify:section:load');
            productSection.dispatchEvent(evt);
            console.log('[PDPSizePicker] dispatched shopify:section:load');
          }
        } else {
          const evt = new Event('shopify:section:load');
          productSection.dispatchEvent(evt);
          console.log('[PDPSizePicker] fallback section load event dispatched');
        }
      } catch (e) {
        console.log('reinitProductSection failed:', e);
      }
    };

    // Helper: compute selected variant from current option inputs
    var getSelectedVariantFromForm = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const sectionEl = productSection.querySelector('[data-section-id]') || document.querySelector('[data-section-id]');
        if (!sectionEl) return null;
        const productJsonEl = document.querySelector('#ProductJson-' + sectionEl.getAttribute('data-section-id'));
        let productData;
        if (productJsonEl) {
          try { productData = JSON.parse(productJsonEl.textContent); } catch(_) {}
        }
        if (!productData && window.__pdpProductData) {
          productData = window.__pdpProductData;
          console.log('[PDPSizePicker] getSelectedVariantFromForm: using cached product data');
        }
        const variantsWrap = productSection.querySelector('[data-product-variants]');
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        let optionInputs = [];
        if (variantsWrap) optionInputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length && formEl) optionInputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) {
          optionInputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
          console.log('[PDPSizePicker] getSelectedVariantFromForm: using section-scoped options', { count: optionInputs.length });
        }
        const selectedOptions = optionInputs.map(input => input.value);
        // If we have product data, try to resolve full variant
        if (productData && productData.variants) {
          let variant = null;
          if (selectedOptions.length) {
            variant = productData.variants.find(v => v && v.options && selectedOptions.every((val, idx) => String(v.options[idx]) === String(val))) || null;
          }
          if (!variant && formEl) {
            const idSelectEl = formEl.querySelector('select[name="id"]');
            const idVal = idSelectEl?.value || formEl.dataset.currentProductId;
            if (idVal) {
              variant = productData.variants.find(v => String(v.id) === String(idVal)) || null;
              if (variant) console.log('[PDPSizePicker] getSelectedVariantFromForm: resolved by select id', { id: idVal });
            }
          }
          return variant;
        }
        // Fallback: no product data; return minimal variant using select id or data-current-variant-id
        const idSelectEl = formEl?.querySelector('select[name="id"]');
        const idVal = idSelectEl?.value || formEl?.dataset.currentProductId || variantsWrap?.getAttribute('data-current-variant-id');
        if (idVal) {
          const minimalVariant = { id: Number(idVal) || idVal };
          console.log('[PDPSizePicker] getSelectedVariantFromForm: minimal variant created', minimalVariant);
          return minimalVariant;
        }
        return null;
      } catch (_) { return null; }
    };

    // Helper: lightly update UI for selected variant (price, data-current-variant-id)
    var applySelectedVariantUI = (variant) => {
      try {
        if (!variant) return;
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const variantsContainer = productSection.querySelector('[data-product-variants]');
        if (variantsContainer) {
          variantsContainer.setAttribute('data-current-variant-id', variant.id);
        }
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        if (formEl) {
          formEl.setAttribute('data-current-product-id', variant.id);
        }
        // Simple price update (fallback if theme bindings are missing)
        const priceEl = productSection.querySelector('[data-price]');
        if (priceEl && typeof variant.price === 'number') {
          const price = (variant.price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          priceEl.textContent = price;
        }
        const compareEl = productSection.querySelector('[data-compare-price]');
        if (compareEl && typeof variant.compare_at_price === 'number' && variant.compare_at_price > variant.price) {
          const compare = (variant.compare_at_price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          compareEl.textContent = compare;
        }
        // Notify listeners
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant } }));
        console.log('[PDPSizePicker] variant UI applied', { id: variant.id });
      } catch (e) { console.log('[PDPSizePicker] applySelectedVariantUI error', e); }
    };

    // Bind variant option listeners with delegation and logs
    var bindVariantOptionListeners = () => {
      try {
        const productSection = document.querySelector('.shopify-section[data-section-type="product"]') || document;
        const variantsWrap = productSection.querySelector('[data-product-variants]');
        const formEl = productSection.querySelector('form[data-product-form]') || document.querySelector('form[data-product-form]');
        let optionInputs = [];
        if (variantsWrap) optionInputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length && formEl) optionInputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
        if (!optionInputs.length) optionInputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
        console.log('[PDPSizePicker] bindVariantOptionListeners: binding', { count: optionInputs.length });
        optionInputs.forEach(input => {
          input.addEventListener('change', () => {
            const currentValues = optionInputs.map(i => i.value);
            console.log('[PDPSizePicker] option change detected', { currentValues });
            syncHiddenIdFromOptions();
            const variant = getSelectedVariantFromForm();
            console.log('[PDPSizePicker] computed variant on change', { id: variant?.id });
            if (variant) applySelectedVariantUI(variant);
          });
        });

        // Delegated listener as safety net
        const delegatedHandler = (e) => {
          const target = e.target;
          if (!target || !target.matches('[name^="options"]')) return;
          if (!productSection.contains(target)) return;
          let inputs = [];
          if (variantsWrap) inputs = Array.from(variantsWrap.querySelectorAll('[name^="options"]'));
          if (!inputs.length && formEl) inputs = Array.from(formEl.querySelectorAll('[name^="options"]'));
          if (!inputs.length) inputs = Array.from(productSection.querySelectorAll('[name^="options"]'));
          const currentValues = inputs.map(i => i.value);
          console.log('[PDPSizePicker] delegated option change', { currentValues });
          syncHiddenIdFromOptions();
          const variant = getSelectedVariantFromForm();
          console.log('[PDPSizePicker] delegated computed variant', { id: variant?.id });
          if (variant) applySelectedVariantUI(variant);
        };
        if (!window.__pdpOptionDelegatedHandler) {
          window.__pdpOptionDelegatedHandler = delegatedHandler;
          document.addEventListener('change', window.__pdpOptionDelegatedHandler, true);
          console.log('[PDPSizePicker] delegated option listener attached');
        }
      } catch (e) {
        console.log('[PDPSizePicker] bindVariantOptionListeners error', e);
      }
    };

    var reinitializeGallery = () => {
      if (window.productGallerySlider) {
        try {
          window.productGallerySlider.destroy();
          window.productGallerySlider = null;
        } catch (e) {
          console.log('Error destroying main slider:', e);
        }
      }

      if (window.productThumbnailSlider) {
        try {
          window.productThumbnailSlider.destroy();
          window.productThumbnailSlider = null;
        } catch (e) {
          console.log('Error destroying thumbnail slider:', e);
        }
      }

      const mainSliderElement = document.querySelector("[js-product-main-slider]");
      if (mainSliderElement) {
        if (window.flu && window.flu.chunks && window.flu.chunks.flickity) {
          import(window.flu.chunks.flickity).then(({ Flickity }) => {
            const mainSlider = new Flickity('[js-product-main-slider]', {
              contain: true,
              adaptiveHeight: true,
              prevNextButtons: true,
              wrapAround: false,
              pageDots: false,
              cellAlign: 'left',
              draggable: true
            });

            let thumbnailSlider;
            const thumbnailElement = document.querySelector("[js-product-thumbnail-slider]");
            if (thumbnailElement) {
              thumbnailSlider = new Flickity('[js-product-thumbnail-slider]', {
                contain: true,
                prevNextButtons: false,
                wrapAround: false,
                pageDots: false,
                cellAlign: 'left',
                draggable: false,
                asNavFor: '[js-product-main-slider]' // Link to main slider
              });
            }

            mainSlider.on('select', function(index) {
              const slideIndex = index || 0;
              
              const productMeasurementInfoWrapperList = document.querySelectorAll('[js-product-measurement-info-wrapper]');
              if (index === 2) {
                productMeasurementInfoWrapperList.forEach(element => {
                  element.classList.add('d-none');
                });
              } else {
                productMeasurementInfoWrapperList.forEach(element => {
                  element.classList.remove('d-none');
                });
              }

              const selectedSlide = mainSlider.selectedElement;
            if (selectedSlide && selectedSlide.hasAttribute('data-inspiration-image-id')) {
              productMeasurementInfoWrapperList.forEach(element => {
                element.classList.add('d-none');
              });
              document.querySelectorAll(`[js-product-inspiration-review-wrapper]`).forEach(element => {
                if (element.getAttribute('data-id') === selectedSlide.getAttribute('data-inspiration-image-id')) {
                  element.classList.add('active');
                } else {
                  element.classList.remove('active');
                }
              });
            } else {
              document.querySelectorAll(`[js-product-inspiration-review-wrapper]`).forEach(element => {
                element.classList.remove('active');
              });
            }
              
              // Only update thumbnail slider if it's not already at this index to prevent infinite loop
              if (thumbnailSlider && thumbnailSlider.selectedIndex !== index) {
                thumbnailSlider.select(index);
              }
              
              const mediaDescriptionWrap = document.querySelector("[js-product-media-description-wrap]");
              const mediaDescriptionEls = document.querySelectorAll("[js-product-media-description]");
              if (index > 0) {
                mediaDescriptionWrap?.classList.add("active");
              } else {
                mediaDescriptionWrap?.classList.remove("active");
              }
              mediaDescriptionEls?.forEach((item) => {
                if (slideIndex === parseInt(item.getAttribute('data-index'))) {
                  item.classList.add('active');
                } else {
                  item.classList.remove('active');
                }
              });
            });

            if (thumbnailSlider) {
              thumbnailSlider.on('select', function(index) {
                // Only update main slider if it's not already at this index to prevent infinite loop
                if (mainSlider.selectedIndex !== index) {
                  mainSlider.select(index);
                }
              });
              
              thumbnailSlider.cells.forEach((slide, index) => {
                slide.element.addEventListener("click", function() {
                  mainSlider.select(index);
                });
              });

              thumbnailSlider.on('ready', () => {
                initializeAllAnimations(thumbnailElement);
                
                // Ensure proper positioning after reinitialization
                setTimeout(() => {
                  // Force layout recalculation
                  thumbnailSlider.resize();
                  
                  // Set initial position without triggering events
                  thumbnailSlider.select(0, false, false);
                  mainSlider.select(0, false, false);
                  
                  // Manually trigger media description updates
                  const mediaDescriptionWrap = document.querySelector("[js-product-media-description-wrap]");
                  const mediaDescriptionEls = document.querySelectorAll("[js-product-media-description]");
                  if (mediaDescriptionWrap) {
                    mediaDescriptionWrap.classList.remove("active");
                  }
                  mediaDescriptionEls?.forEach((item) => {
                    if (parseInt(item.getAttribute('data-index')) === 0) {
                      item.classList.add('active');
                    } else {
                      item.classList.remove('active');
                    }
                  });
                  
                  // Force another resize to ensure proper layout
                  setTimeout(() => {
                    thumbnailSlider.resize();
                    mainSlider.resize();
                  }, 100);
                }, 100);
              });
            }
            
            window.productGallerySlider = mainSlider;
            
            const productTitle = document.querySelector(".product__title");
            if (productTitle) {
              const newProductTitle = productTitle.cloneNode(true);
              productTitle.parentNode.replaceChild(newProductTitle, productTitle);
              
              newProductTitle.addEventListener("click", function() {
                mainSlider.next();
              });
            }
          }).catch(e => {
            console.log('Error initializing Flickity:', e);
          });
        } else {
          setTimeout(() => {
            if (window.Flickity) {
              const mainSlider = new window.Flickity('[js-product-main-slider]', {
                contain: true,
                adaptiveHeight: true,
                prevNextButtons: true,
                wrapAround: false,
                pageDots: false,
                cellAlign: 'left'
              });
              
              const thumbnailElement = document.querySelector("[js-product-thumbnail-slider]");
              if (thumbnailElement) {
                const thumbnailSlider = new window.Flickity('[js-product-thumbnail-slider]', {
                  contain: true,
                  prevNextButtons: false,
                  wrapAround: false,
                  pageDots: false,
                  cellAlign: 'left',
                  draggable: false
                });
                
                thumbnailSlider.on('ready', () => {
                  window.productThumbnailSlider = thumbnailSlider;
                  initializeAllAnimations(thumbnailElement);
                  
                  // Ensure proper positioning after reinitialization
                  setTimeout(() => {
                    // Force layout recalculation
                    thumbnailSlider.resize();
                    
                    // Set initial position without triggering events
                    thumbnailSlider.select(0, false, false);
                    mainSlider.select(0, false, false);
                    
                    // Manually trigger media description updates
                    const mediaDescriptionWrap = document.querySelector("[js-product-media-description-wrap]");
                    const mediaDescriptionEls = document.querySelectorAll("[js-product-media-description]");
                    if (mediaDescriptionWrap) {
                      mediaDescriptionWrap.classList.remove("active");
                    }
                    mediaDescriptionEls?.forEach((item, i) => {
                      if (parseInt(item.getAttribute('data-index')) === 0) {
                        item.classList.add('active');
                      } else {
                        item.classList.remove('active');
                      }
                    });
                    
                    // Force another resize to ensure proper layout
                    setTimeout(() => {
                      thumbnailSlider.resize();
                      mainSlider.resize();
                    }, 100);
                  }, 100);
                });

                window.productThumbnailSlider = thumbnailSlider;
              }
              
              window.productGallerySlider = mainSlider;
            }
          }, 100);
        }
      }

      if (window.theme && window.theme.Product) {
        try {
          window.theme.Product.init();
        } catch (e) {
          console.log('Theme Product init failed:', e);
        }
      }
      
      document.dispatchEvent(new CustomEvent('gallery:reinit'));

      // Reload product section so ProductForm bindings are restored (theme uses Sections API)
      try {
        reinitProductSection();
      } catch (e) {
        console.log('Product section reload failed:', e);
      }

      window.ProductMainSliderApp.init();
    };

    var updateProductInfo = async (productUrl) => {
      try {
        window.location.href = productUrl;
      } catch (error) {
        console.error('Error updating product info:', error);
        // Fallback to regular page redirect if something goes wrong
        window.location.href = productUrl;
      } finally {
        // Remove loading state
        const container = document.querySelector('.product__size-picker');
        if (container) container.classList.remove('size-picker-loading');
      }
    };

    var calculateScrollProgress = (container, dragging = false, initialize = false) => {
      if (!container) return;
      const activeImage = container.querySelector('[js-image].active');
      const scrollBar = container.querySelector('[js-scroll-bar]');
      const imageList = container.querySelector('[js-image-list]');
      if (!scrollBar || !imageList) return;
      imageList.scrollTo(activeImage.getBoundingClientRect().left - imageList.getBoundingClientRect().left + imageList.scrollLeft - (imageList.clientWidth - activeImage.clientWidth) / 2, 0);
      if (!dragging) {
        setTimeout(() => {
          scrollBar.style.setProperty('--progress', activeImage.getBoundingClientRect().left - imageList.getBoundingClientRect().left + activeImage.offsetWidth / 2 + 'px');
        }, 150);
        if (!initialize) {
          setTimeout(() => {
            const productUrl = activeImage.getAttribute('data-href');
            if (productUrl) {
              updateProductInfo(productUrl);
            }
          }, 300);
        }
      }
    }
    
    var moveScrollBar = (container, percent, dragging = false) => {
      if (!container) return;
      const totalIndex = parseInt(container.getAttribute('data-total-index')) - 1;
      const unitPercent = 100 / totalIndex;
      let index = 0;
      if (percent <= unitPercent / 2) {
        index = 0;
      } else if (percent > (100 - unitPercent / 2)) {
        index = totalIndex;
      } else {
        for (let i = 1; i <= totalIndex - 1; i++) {
          if (percent > (unitPercent / 2 + unitPercent * (i - 1)) && percent <= (unitPercent / 2 + unitPercent * i)) {
            index = i;
          }
        }
      }
      setCurrentImage(container, container.querySelector(`[js-image][data-index="${index}"]`), dragging);
    }
    
    var setCurrentImage = (container, image, dragging = false) => {
      if (!container || !image) return;
      container.querySelectorAll('[js-image]').forEach(element => {
        element.classList.remove('active');
      });
      image.classList.add('active');
      calculateScrollProgress(container, dragging);
    }
    
    var startDragScroll = (container) => {
      if (!container) return;
      container.classList.add('dragging');
    }
    
    var dragScroll = (container, x) => {
      if (!container || !container.classList.contains('dragging')) return;
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.style.setProperty('--transition', '0s');
      let progressValue = x - scrollBar.getBoundingClientRect().left;
      progressValue = (progressValue<0)?0:progressValue;
      progressValue = (progressValue>scrollBar.clientWidth)?(scrollBar.clientWidth):progressValue;
      scrollBar.style.setProperty('--progress', progressValue + 'px');
      moveScrollBar(container, progressValue*100/scrollBar.clientWidth, true);
    }
    
    var endDragScroll = (container) => {
      if (!container || !container.classList.contains('dragging')) return;
      container.classList.remove('dragging');
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.style.setProperty('--transition', '0.3s');
      calculateScrollProgress(container);
    }
    
    var initEachSlider = (container) => {
      if (!container) return;
      const imageList = container.querySelector('[js-image-list]');
      if (imageList && imageList.scrollWidth == imageList.clientWidth) {
        imageList.style.justifyContent = 'space-around';
      }
      calculateScrollProgress(container, false, true);
      container.querySelectorAll('[js-image]').forEach(element => {
        element.addEventListener('click', () => {
          setCurrentImage(container, element);
        });
      });
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.addEventListener('click', (event) => {
        moveScrollBar(container, (event.clientX - scrollBar.getBoundingClientRect().left) * 100 / scrollBar.clientWidth);
      });
      const scrollHandler = container.querySelector('[js-scroll-handler]');
      if (!scrollHandler) return;
      scrollHandler.addEventListener('mousedown', () => {
        startDragScroll(container);
      });
      document.addEventListener('mousemove', (event) => {
        dragScroll(container, event.clientX);
      });
      document.addEventListener('mouseup', () => {
        endDragScroll(container);
      });
      scrollHandler.addEventListener('touchstart', () => {
        startDragScroll(container);
      });
      document.addEventListener('touchmove', (event) => {
        dragScroll(container, event.touches[0].clientX);
      });
      document.addEventListener('touchend', () => {
        endDragScroll(container);
      });
    }
    
    var initialize = () => {
      document.querySelectorAll('[js-pdp-size-picker]').forEach(container => {
        initEachSlider(container);
      });
    }
    
    return {
      init: initialize
    }
  })();

  var ThresholdSystemApp = (() => {
    var isAddedGiftProduct = (cart, variant_id) => {
      let result = false;
      Array.from(cart.items).forEach(item => {
        if (item.variant_id == variant_id && item.properties['_is_free_gift'] === 'true') {
          result = true;
        }
      });
      return result;
    }
    var addGiftProduct = async (variant_id, required_product_id_list, required_product_count) => {
      const cart = await window.cart.get();
      if (isAddedGiftProduct(cart, variant_id)) {
        return;
      }
      if (required_product_count > 0) {
        window.cart.addItemById(variant_id, 1, {'_is_free_gift': 'true', '_required_product_id_list': required_product_id_list, '_required_product_count': required_product_count});
      }
    }
    var updateThreshold = (container, cart) => {
      console.log('here is updatethreshold');
      if (!container || !cart) return;
      let product_from_collection_count = 0;
      let current_step = 0;
      const product_id_list = String(container.getAttribute('data-threshold-product-id-list-for-gift')).split(',');
      Array.from(cart.items).forEach(item => {
        current_step = 1;
        if (product_id_list.includes(String(item.variant_id))) {
          product_from_collection_count+=item.quantity;
        }
      });
      console.log('product_from_collection_count', product_from_collection_count);
      if (product_from_collection_count >= parseInt(container.getAttribute('data-threshold-collection-product-count'))) {
        current_step = 2;
      }
      container.querySelectorAll('[is-free-gift]').forEach(element => {
        element.classList.remove('is-adding');
      });
      let progress = product_from_collection_count * 100 / parseInt(container.getAttribute('data-threshold-collection-product-count'));
      progress = (progress > 100) ? 100 : progress;

      const shippingLabel = document.querySelector('.quick-cart .shipping-price');

      let shippingThreshold = 0;
      let shippingValue = 0;
      let shippingProgress = 100;
      if (document.body.hasAttribute('shipping-threshold-ab-test-1')) {
        shippingThreshold = parseInt(container.getAttribute('data-shipping-threshold-1'));
        shippingValue = parseInt(container.getAttribute('data-shipping-value-1'));
      }
      if (document.body.hasAttribute('shipping-threshold-ab-test-2')) {
        shippingThreshold = parseInt(container.getAttribute('data-shipping-threshold-2'));
        shippingValue = parseInt(container.getAttribute('data-shipping-value-2'));
      }
      const free_shipping_product_id_list = String(container.getAttribute('data-free-shipping-product-id-list')).trim().split(',');
      let free_shipping = true;
      Array.from(cart.items).forEach(item => {
        if (!free_shipping_product_id_list.includes(String(item.product_id))) free_shipping = false;
      });
      if (cart.total_price <= shippingThreshold && free_shipping === false) {
        current_step = 0;
        progress = 0;
        shippingProgress = cart.total_price * 100 / shippingThreshold;
        if (shippingLabel) {
          shippingLabel.innerHTML = window.formatMoney(shippingValue);
        }
      } else {
        shippingLabel.innerHTML = shippingLabel.getAttribute('data-free-shipping-text');
      }

      if (container.querySelector('[data-shipping-template]')) {
        container.querySelector('[data-shipping-template]').innerHTML = String(container.querySelector('[data-shipping-template]').getAttribute('data-shipping-template')).replace('((value))', window.formatMoney(shippingThreshold - cart.total_price));
      }

      if (current_step > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            attributes: {
              _free_shipping_flag: 'true',
            },
          }),
        });
      } else {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            attributes: {
              _free_shipping_flag: null,
            },
          }),
        });
      }

      container.style.setProperty('--progress', progress + '%');
      container.style.setProperty('--shipping-progress', shippingProgress + '%');
      container.setAttribute('data-step', current_step);
      let successFlag = false;
      if (current_step == 2) {
        successFlag = true;
      }
      container.querySelectorAll('[is-free-gift]').forEach(element => {
        element.classList.remove('d-none');
        if (isAddedGiftProduct(cart, element.getAttribute('is-free-gift'))) {
          element.classList.add('d-none');
        } else {
          successFlag = false;
        }
      });
      if (successFlag == true) {
        container.setAttribute('data-step', 'success');
      }
    }
    var initEachContainer = (container) => {
      if (!container) {
        return;
      }
      if (parseInt(container.getAttribute('data-step')) == 2) {
        let successFlag = true;
        container.querySelectorAll('[is-free-gift]').forEach(element => {
          if (!element.classList.contains('d-none')) successFlag = false;
        });
        if (successFlag) {
          container.setAttribute('data-step', 'success');
        }
      }
      document.addEventListener('threshold-system:product-id-list-for-gift:updated', () => {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            updateThreshold(container, cart);
          })
          .catch(error => console.error('Error:', error));
      });
      document.addEventListener('cart:updated', (event) => {
        console.log('here is the cart items', event.detail.cart.items);
        updateThreshold(container, event.detail.cart);
      });
      container.querySelectorAll('[is-free-gift] [js-atc]').forEach(element => {
        element.addEventListener('click', () => {
          const wrapper = element.closest('[is-free-gift]');
          if (wrapper.classList.contains('is-adding')) return;
          wrapper.classList.add('is-adding');
          addGiftProduct(wrapper.getAttribute('is-free-gift'), container.getAttribute('data-threshold-product-id-list-for-gift'), parseInt(container.getAttribute('data-threshold-collection-product-count')));
        });
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-threshold-system]').forEach(container => {
        initEachContainer(container);
      });
    }
    return {
      init: initialize
    }
  })();

  var CollectionFilterTabApp = (() => {
    var filter = (trigger_id, container) => {
      if (!trigger_id || trigger_id === '' || !container) return;
      container.querySelectorAll('[js-trigger]').forEach(element => {
        if (element.getAttribute('js-trigger') === String(trigger_id)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
      window.mediaFlickityInstances.forEach(element => {
        element.select(parseInt(trigger_id));
      });
      window.collectionSliderMediaFlickityInstances.forEach(element => {
        element.select(parseInt(trigger_id));
      });
      container.setAttribute('data-current-trigger-id', trigger_id);

      document.querySelectorAll('.slider-product-item .media-slider-wrapper').forEach(element => {
        element.scrollTo(element.clientWidth * parseInt(trigger_id), 0);
        element.querySelectorAll('.media-slider-image-dots [data-id]').forEach(dot => {
          dot.classList.remove('active');
          if (dot.getAttribute('data-id') === String(trigger_id)) {
            dot.classList.add('active');
          }
        });
      });
    }
    var setFilterTabVisibility = () => {
      let flag = false;
      document.querySelectorAll('.bd-product-list-slider').forEach(element => {
        if (element.getBoundingClientRect().top < window.innerHeight && element.getBoundingClientRect().top + element.getBoundingClientRect().height > window.innerHeight / 2) {
          flag = true;
        }
      });
      document.querySelectorAll('.collection-filter--wrapper').forEach(element => {
        if (flag) {
          element.classList.remove('disabled');
        } else {
          element.classList.add('disabled');
        }
      });
    }
    var initialize = () => {
      let firstView = true;
      const targetElement = document.querySelector('.collection__products .product-item'); 

      if (!targetElement) return;

      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && firstView) {
            firstView = false;
            setTimeout(() => {
              const firstMediaWrapper = window.mediaFlickityInstances[0];
              if (firstMediaWrapper) {
                firstMediaWrapper.select(1);
                setTimeout(() => {
                  firstMediaWrapper.select(0);
                }, 500);
              }
              const firstCollectionSliderMediaWrapper = window.collectionSliderMediaFlickityInstances[0];
              if (firstCollectionSliderMediaWrapper) {
                firstCollectionSliderMediaWrapper.select(1);
                setTimeout(() => {
                  firstCollectionSliderMediaWrapper.select(0);
                }, 500);
              }
            }, 1000);
          }
        });
      });
      observer.observe(targetElement);
      
      document.querySelectorAll('[js-collection-filter] [js-trigger]').forEach(element => {
        element.addEventListener('click', () => {
          filter(element.getAttribute('js-trigger'), element.closest('[js-collection-filter]'));
        });
      });

      if (document.body.hasAttribute('collection-page-redesign-ab-test')) {
        window.addEventListener('scroll', () => {
          setFilterTabVisibility();
        });
      }
    }
    return {
      init: initialize
    }
  })();

  var BDProductListSliderApp = (() => {
    var renderSlides = () => {
      document.querySelectorAll('[js-bd-product-list-slider]').forEach(slider => {
        if (slider.getBoundingClientRect().y <= window.innerHeight + 1000 && slider.getBoundingClientRect().y >= -1 * (slider.getBoundingClientRect().height - 1000) || true) {
          // var flkty = new Flickity( slider, {
          //   draggable: true,
          //   pageDots: false,
          //   prevNextButtons: true,
          //   cellAlign: "center",
          //   adaptiveHeight: false,
          //   contain: true,
          //   resize: true,
          //   wrapAround: true
          // });
        }
      });
    }
    var initialize = () => {
      renderSlides();
      window.addEventListener('scroll', () => {
        renderSlides();
      })
    }
    return {
      init: initialize
    }
  })()
  var PDPDividedPriceApp = (() => {
    var initialize = () => {
      document.addEventListener("product:variant-change", function (evt) {
        document.querySelectorAll('[js-divided-price]').forEach(element => {
          if (String(element.getAttribute('data-variant-id')) === String(evt.detail.variant.id)) {
            element.classList.add('active');
          } else {
            element.classList.remove('active');
          }
        });
      });
    }
    return {
      init: initialize
    }
  })();

  var CartDrawerUpsellApp = (() => {
    var isFinishedThreshold = () => {
      const thresholdSystem = document.querySelector('[js-threshold-system]');
      if (!thresholdSystem) return false;
      const current_step = thresholdSystem.getAttribute('data-step');
      if (!thresholdSystem.querySelector('.progress-bar__icon[data-step]:last-of-type')) return;
      const final_step = thresholdSystem.querySelector('.progress-bar__icon[data-step]:last-of-type').getAttribute('data-step');
      if (current_step === final_step) return true;
    }
    var findVariantByOptions = (variants, selectedOptions) => {
      return variants.find(variant => {
        return selectedOptions.every((value, index) => {
          const optionKey = `option${index + 1}`;
          return variant[optionKey] === value;
        });
      });
    }
    var getSelectedVariant = (upsellProduct) => {
      if (!upsellProduct) return;
      const variantDataScript = upsellProduct.querySelector('[data-product-variants]');
      if (!variantDataScript) return null;

      const productData = JSON.parse(variantDataScript.textContent);
      const selects = upsellProduct.querySelectorAll('select');
      
      const selectedOptions = Array.from(selects).map(select => select.value);
      
      return findVariantByOptions(productData.variants, selectedOptions);
    }
    var renderUpsellWrapper = () => {
      fetch('/?section_id=header')
      .then(response => response.text())
      .then(html => {
        const upsellWrapper = new DOMParser().parseFromString(html, 'text/html').querySelector('.quick-cart [data-items]+[js-quick-cart-upsell-product-list]');
        const upsell_wrapper_html = upsellWrapper ? upsellWrapper.outerHTML : '';
        const cartItemsWrapper = document.querySelector('.quick-cart [data-items]');
        if (cartItemsWrapper) {
          if (cartItemsWrapper.querySelector('[js-quick-cart-upsell-product-list]')) {
            cartItemsWrapper.querySelector('[js-quick-cart-upsell-product-list]').outerHTML = upsell_wrapper_html;
          } else {
            cartItemsWrapper.innerHTML += upsell_wrapper_html;
          }
          const upsellListSlider = cartItemsWrapper.querySelector('[js-quick-cart-upsell-product-list] .heading+div');
          if (upsellListSlider) {
            upsellListSlider.closest('[js-quick-cart-upsell-product-list]').classList.remove('d-none');
            const f = new Flickity(upsellListSlider, {
              cellAlign: "left",
              contain: true,
              pageDots: false,
              prevNextButtons: false
            });
            if (isFinishedThreshold() === true) upsellListSlider.closest('[js-quick-cart-upsell-product-list]').classList.add('d-none');
            upsellListSlider.querySelectorAll('.upsell-product .variant-option select').forEach(element => {
              element.addEventListener('change', () => {
                const customSelect = element.closest('.variant-option').querySelector('.custom-select [data-option-name]');
                if (customSelect) {
                  customSelect.innerHTML  = `${customSelect.getAttribute('data-option-name')}: ${element.value}`;
                }
                const variant = getSelectedVariant(element.closest('.upsell-product'));
                if (variant) {
                  element.closest('.upsell-product').querySelectorAll('.price').forEach(price => {
                    price.classList.remove('active');
                    if (price.getAttribute('data-variant-id') === String(variant.id)) {
                      price.classList.add('active');
                    }
                  });
                }
              });
            });
            upsellListSlider.querySelectorAll('.upsell-product [js-add]').forEach(element => {
              element.addEventListener('click', () => {
                const variant = getSelectedVariant(element.closest('.upsell-product'));
                if (variant) {
                  element.closest('.upsell-product').classList.add('loading'); 
                  window.cart.addItemById(variant.id, 1);
                }
              });
            });
          }
        }
      })
      .catch(error => {
        console.error('Error fetching cart drawer section:', error);
      });
    }
    var initialize = () => {
      renderUpsellWrapper();
      document.addEventListener('cart:updated', (event) => {
        renderUpsellWrapper();
      });

      function handleUpsellAppear(element) {
        console.log('Upsell product list appeared in viewport!');
        window.dispatchEvent(new Event('resize'));
      }

      const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            handleUpsellAppear(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px'
      });

      function observeUpsellList() {
        const upsellElement = document.querySelector('[js-quick-cart-upsell-product-list] .heading+div');
        
        if (upsellElement) {
          intersectionObserver.observe(upsellElement);
        }
      }

      const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach(() => {
          observeUpsellList();
        });
      });

      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });

      observeUpsellList();
    }
    return {
      init: initialize
    }
  })();

  var BundleVariantOptionApp = (() => {
    var addInputsToProductForm = (variant_id, variant_price, bundle_info) => {
      if (!bundle_info || !variant_id) return;
      const productFormElement = document.querySelector('[js-main-product] [data-product-form]');
      if (productFormElement) {
        const bundleId = `bndl_${Date.now()}_${Math.random().toString(16).slice(2)}`;
        const new_input_elements_html = Array.from(bundle_info.children_variant).map((variant_info, index) => {
          return `
            <input js-variant-bundle-input type="hidden" name="items[${index}][id]" value="${variant_info.variant.id}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][quantity]" value="${variant_info.quantity}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_id]" value="${bundleId}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_parent_variant]" value="${variant_id}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_parent_price]" value="${variant_price}">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_role]" value="child">
            <input js-variant-bundle-input type="hidden" name="items[${index}][properties][_bundle_index]" value="${index}">
          `;
        }).join("");
        productFormElement.innerHTML = productFormElement.innerHTML + new_input_elements_html;
        const quantityInputElement = productFormElement.querySelector('input[name="quantity"]');
        if (quantityInputElement) {
          quantityInputElement.setAttribute('data-temp-value', quantityInputElement.value);
          quantityInputElement.value = 0;
        }
      }
    }
    var removeInputsFromProductForm = () => {
      document.querySelectorAll('[js-main-product] [data-product-form] [js-variant-bundle-input]').forEach(element => {
        element.remove();
      });
      const quantityInputElement = document.querySelector('[js-main-product] [data-product-form] input[name="quantity"]');
      if (quantityInputElement) {
        quantityInputElement.value = quantityInputElement.getAttribute('data-temp-value');
      }
    }
    var updateBundleIdAfterSubmit = () => {
      document.querySelectorAll('input[name^="items["][name$="[properties][_bundle_id]"]').forEach(element => {
        element.value = element.value + 'changed';
      });
    }
    var initialize = () => {
      document.addEventListener('product:variant-change', (event) => {
        const variant_id = event.detail.variant.id;
        const variant_price = event.detail.variant.price / 100;
        let normal_variant_flag = true;
        if (BUNDLE_VARIANT_INFO[variant_id]) {
          addInputsToProductForm(variant_id, variant_price, BUNDLE_VARIANT_INFO[variant_id]);
          normal_variant_flag = false;
        }
        if (normal_variant_flag === true) {
          removeInputsFromProductForm();
        }
      });
      document.addEventListener('cart:item-added', () => {
        updateBundleIdAfterSubmit();
      });
    }
    return {
      init: initialize
    }
  })();

  var App = (() => {
    var initialize = () => {
      CollectionBundleHighlightApp.init();
      AnchorApp.init();
      PDPSizePickerApp.init();
      ProductMeasurementInfoWrapperApp.init();
      ThresholdSystemApp.init();
      CollectionFilterTabApp.init();
      BDProductListSliderApp.init();
      PDPDividedPriceApp.init();
      CartDrawerUpsellApp.init();
      BundleVariantOptionApp.init();
      // Initialize custom dropdowns on page load
      initializeCustomDropdowns();
    }
    return {
      init: initialize
    }
  })();


  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });

})();

const mainCollection = document.querySelector("[js-main-collection]");
if(mainCollection) {
  document.addEventListener("click", function({ target }) {
    const sortByField = mainCollection.querySelector("[js-sort-by-field]");
    if(target.hasAttribute('js-sort-by-item')) {
      const value = target.getAttribute("data-value");
      sortByField.value = value;
      sortByField.dispatchEvent(new Event('input', {'view': window,'bubbles': true}))
      mainCollection.querySelector("[js-sort-by-details]")?.removeAttribute("open")
    };
  });
}